import { useEffect } from 'react';

const ATRIBUCION = 'Caso clínico de ConsaludENARM · consaludenarm.com';

/** Al copiar texto de la página, el portapapeles lleva la atribución a ConsaludENARM. */
export function useAtribucionAlCopiar() {
  useEffect(() => {
    const onCopy = (e: ClipboardEvent) => {
      const sel = window.getSelection();
      const texto = sel?.toString().trim();
      if (!sel || !texto || !e.clipboardData) return;
      const div = document.createElement('div');
      for (let i = 0; i < sel.rangeCount; i++) div.append(sel.getRangeAt(i).cloneContents());
      e.clipboardData.setData('text/plain', `${texto}\n\n— ${ATRIBUCION}`);
      e.clipboardData.setData('text/html', `${div.innerHTML}<p><b>— ${ATRIBUCION}</b></p>`);
      e.preventDefault();
    };
    document.addEventListener('copy', onCopy);
    return () => document.removeEventListener('copy', onCopy);
  }, []);
}
